import { render, staticRenderFns } from "./ComponentHowto.vue?vue&type=template&id=4462a814&scoped=true"
import script from "./ComponentHowto.vue?vue&type=script&lang=js"
export * from "./ComponentHowto.vue?vue&type=script&lang=js"
import style0 from "./ComponentHowto.vue?vue&type=style&index=0&id=4462a814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4462a814",
  null
  
)

export default component.exports